export const base64ToBlob = (base64: string): Blob => {
  const content = atob(base64);
  return new Blob([content], { type: 'data:application/octet-stream;base64' });
};

export const base64ToBlobPdf = (base64: string): Blob => {
  const cleanedBase64 = base64.includes(',') ? base64.slice(base64.indexOf(',') + 1) : base64;

  const binary = atob(cleanedBase64);
  const len = binary.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: 'application/pdf' });
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};

export const blobToJson = (blob: Blob): Promise<JSON> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(JSON.parse(reader.result as string) as JSON);
    reader.readAsText(blob);
  });
};
